import React, { useState } from "react";
import Header from "../components/Header";
import AdminSidePanel from "../components/AdminSidePanel";
import UserTable from "../components/UserTable";
import "./Admin.css"

const UserManPage = () => {
    const [sidePanelOpen, setSidePanelOpen] = useState(false);

    return (
        <div>
            <Header />

            <div style={{ padding: '20px 20px 0' }}>
                <button
                onClick={() => setSidePanelOpen(true)}
                style={{
                    padding: '8px 12px',
                    fontSize: '16px',
                    backgroundColor: '#F4A261',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#5E503F'
                }}
                >
                ☰ Menu
                </button>
            </div>

            {sidePanelOpen && (
                <div className="overlay" onClick={() => setSidePanelOpen(false)} />
            )}

            <div className={`sidePanel ${sidePanelOpen ? 'open' : ''}`}>
                <button
                onClick={() => setSidePanelOpen(false)}
                style={{
                    marginLeft: '12px',
                    marginBottom: '20px',
                    fontSize: '18px',
                    background: 'none',
                    border: 'none',
                    color: '#5E503F',
                    cursor: 'pointer'
                }}
                >
                ✖ Close
                </button>
                <AdminSidePanel />
            </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                    <UserTable />
                </div>
                
                
                
        </div>
    );
};

export default UserManPage;